export default __webpack_public_path__ + "static/media/cancha.3f1a66c0.jpg";